import { writable, readable } from 'svelte/store';

export const editable = writable(true);
export const roles = writable([]);
export const rolesTotalTime = writable({});
export const elementInstance = writable(null);
export const selectedSequence = writable(null);
export const branchId = writable(0);
export const location = writable('');
export const elementDetails = writable(null);
export const draftElementDetails = writable(null);
export const messages = writable(null);
export const loadingElementDetails = writable(false);
export const standaloneEdit = writable(false);
export const readOnly = writable(false);
export const triggerNewDraftElementVersionCreation = writable(false);
export const activityVersion = writable(null);
export const isMaterialRiskControlSelected = writable(false);
export const isSaveEdit = writable(true);
export const isActivityVersionHeaderSelected = writable(true);
export const isAPM = writable(true);

const elementTypesList = [
  {
    id: 'KNACK',
    name: "$$KNACK$$",
    faIcon: { classes: 'fas fa5-cog', style: 'color: #1B67B1;' },
  },
  {
    id: 'PART',
    name: "$$PART$$",
    faIcon: { classes: 'fas fa5-cube', style: 'color: #9D2F92;' },
  },
  {
    id: 'QUALITY',
    name: "$$QUALITY$$",
    faIcon: { classes: 'fas fa5-search', style: 'color: #2FA3D7;' },
  },
  {
    id: 'SAFETY',
    name: "$$SAFETY$$",
    faIcon: { classes: 'fas fa5-medkit', style: 'color: #F47B2E;' },
  },
  {
    id: 'TOOL',
    name: "$$TOOL_1$$",
    faIcon: { classes: 'fas fa5-wrench', style: 'color: #02AB8B;' },
  },
];

const allType = {
  id: 'ALL',
  name: "$$SHOW_2$$",
  faIcon: { classes: 'fas fa5-check-circle', style: 'color: #5EA832' },
};

export const elementTypes = readable(elementTypesList);

const elementTypesListWithAll = [allType].concat(elementTypesList);
export const elementTypesWithAll = readable(elementTypesListWithAll);

const strategyFilterTypesWithAll = ['ALL', 'PART', 'QUALITY'];

// -- In combined contextual diff view, Strategy Approver should have visibility of SAFETY Elements as well.
const contextualStrategyFilterTypesWithAll = ['ALL', 'PART', 'QUALITY', 'SAFETY'];

export const strategyElementTypesWithAll = readable(
  elementTypesListWithAll.filter((elType) =>
    strategyFilterTypesWithAll.includes(elType.id)
  )
);

export const contextualStrategyElementTypesWithAll = readable(
  elementTypesListWithAll.filter((elType) =>
    contextualStrategyFilterTypesWithAll.includes(elType.id)
  )
);

export const currentNewElementButtonId = writable('');

export const isEditingName = writable(false);
export const elementsUsedInActivity = writable([]);
export const csrfMiddlewareToken = writable('');

export const defaultElementTypeKey = 'defaultElementType';
export const lastLMIKey = 'lastLMI';
export const lastExecutionConditionKey = 'lastExecutionCondition';
export const selectedListColumnsKey = 'selectedListColumns';
